<template>
	<div>
		<div
			:class="{
				[$style.air__sidebar]: true,
				[$style.air__sidebar__toggled]: visible
			}"
		>
			<vue-custom-scrollbar :style="{ height: '100%' }">
				<div :class="$style.air__sidebar__inner">
					<a
						:class="$style.air__sidebar__close"
						@click="visible = !visible"
					>
						<a-icon type="close" />
					</a>
					<h5>
						<strong><span class="blink">_</span>DEV</strong> Options
					</h5>
					<div
						class="air__utils__line"
						:style="{ marginTop: '25px', marginBottom: '30px' }"
					/>
					<p class="mb-5 text-justify">
						🤖 ¿Trabajas con nuestro panel? Ajusta las opciones según tus necesidades
					</p>
					<!-- ENTORNO v-if="$env.NODE_ENV==='production'" -->
					<div

						:class="$style.air__sidebar__type"
						class="border-top-0 mt-0"
					>
						<div :class="$style.air__sidebar__type__title">
							<span>🌎 Entorno</span>
							<g-help title="El Entorno">
								Dependiendo del tipo de entorno
								conectarás con una instancia distinta.
								Producción, desarrollo o instancia local.
							</g-help>
						</div>
						<div :class="[$style.air__sidebar__type__items]">
							<a-radio-group v-model="environment">
								<a-radio-button value="production">
									PRO
								</a-radio-button>
								<a-radio-button value="development">
									DEV
								</a-radio-button>
							</a-radio-group>
							<div class="clearfix" />
						</div>
					</div>
					<div
						:class="$style.air__sidebar__type"
						class="pb-0"
					>
						<div
							:class="$style.air__sidebar__type__title"
							class="mb-4"
						>
							<span>🌜 Modo oscuro</span>
							<a-switch
								:checked="$settings.dark"
								@click="settingChange($event, 'dark')"
							/>
						</div>

						<div
							:class="$style.air__sidebar__type__title"
						>
							<span>🤖 Modo debug</span>
							<a-switch
								:checked="$settings.debug"
								@click="settingChange($event, 'debug')"
							/>
						</div>
					</div>
					<!-- PATHS -->
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>🔗 Paths</span>
							<g-help title="Variables">
								Aquí puedes visualizar los paths que apuntan a cada entorno.
							</g-help>
						</div>

						<div
							:class="$style.air__sidebar__item"
							class="mb-4 flex-column align-items-start"
						>
							<a-input
								placeholder="API"
								:value="api"
								:disabled="true"
							>
								<g-help
									slot="prefix"
									title="API"
								>
									Ruta de la API de GestiOS que procesará todos los datos.
								</g-help>
							</a-input>
						</div>
						<div
							:class="$style.air__sidebar__item"
							class="mb-4 flex-column align-items-start"
						>
							<a-input
								placeholder="Lambda"
								:disabled="true"
								:value="$app.paths.lambda"
							>
								<g-help
									slot="prefix"
									title="Lambda"
								>
									<p>API externa que realiza determinadas acciones adicionales a GestiOS.</p>
									<b>Estado: </b> <span class="text-success">En uso</span>
								</g-help>
							</a-input>
						</div>
					</div>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>📦 Proyecto</span>
						</div>

						<div :class="$style.air__sidebar__item">
							<a-input
								:value="$gestios.project.name"
								:disabled="true"
							/>
						</div>

						<div :class="$style.air__sidebar__type__title">
							<span>📦 Pack</span>
						</div>
						<div :class="$style.air__sidebar__item">
							<a-input
								:value="pack"
								:disabled="true"
							/>
						</div>
					</div>
				</div>
			</vue-custom-scrollbar>
		</div>
	</div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';

export default {
	components: { VueCustomScrollbar },
	data() {
		return {
			visible: false
		};
	},
	computed: {
		environment: {
			get() {
				return this.$settings.env;
			},
			set(value) {
				// if (this.$env.NODE_ENV === 'production'
				// && (value === 'production' || value === 'development')) {
				if ((value === 'production' || value === 'development')) {
					this.$store.commit('CHANGE_SETTING', { setting: 'env', value });
					this.$settings.env = value;
				}

				switch (value) {
					case 'development':
						this.$toast.info('Los datos introducidos en el modo desarrollo vuelven a su estado real cada día a las 02:00');
						break;

					case 'local':
						this.$toast.info('Para poder trabajar en un entorno local debes tener configurada una instancia de GestiOS');
						break;

					default:
				}
			}
		},
		api() {
			if (this.environment === 'production') return this.$app.paths.api;
			return this.$app.paths.api_dev;
		},
		pack() {
			if (this.$app.pack) return this.$app.pack;
			return this.$gestios.project.name;
		}
	},
	watch: {
		api(cal) {
			this.$gestios.url = cal;
		}
	},
	created() {
		this.$gestios.url = this.api;

		this.$hub.$on('_toggleDevSettings', () => {
			this.visible = !this.visible;
		});
	},
	destroyed() {
		this.$hub.$off('_toggleDevSettings');
	},
	methods: {
		settingChange(e, setting) {
			const value = !this.$settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
